import styled from 'styled-components';
import SetupGuideNav from '../nav/SetupGuideNav';
import { SETUP_GUIDE_TWO_COLUMNS_BREAKPOINT_PX } from '../../constants/layoutConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Manually setting flex properties, as I need to change its behaviour based on breakpoints
// and this is not supported by View/Flex even if I style them.
const SetupGuideNavLayout = styled.div.withConfig({
  displayName: "SetupGuideLayout__SetupGuideNavLayout",
  componentId: "hatnox-0"
})(({
  theme
}) => `
  background: ${theme.color['fill-surface-raised']};
  height: calc(100vh - var(--global-nav-height));
  display: flex;
  align-items: stretch;
  justify-content: center;
  overflow-y: auto;

  @media only screen and (max-width: ${SETUP_GUIDE_TWO_COLUMNS_BREAKPOINT_PX}px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`);
const SetupGuideNavContainer = styled.div.withConfig({
  displayName: "SetupGuideLayout__SetupGuideNavContainer",
  componentId: "hatnox-1"
})(({
  theme
}) => `
  width: 256px;
  padding-block: ${theme.space['0']};
  padding-inline: ${theme.space['800']};
  overflow-y: auto;
  position: sticky;
  top: 0;
  flex-shrink: 0;

  @media only screen and (max-width: ${SETUP_GUIDE_TWO_COLUMNS_BREAKPOINT_PX}px) {
    position: relative;
    width: unset;
    background: ${theme.color['fill-surface-default']};
    box-shadow: ${theme.boxShadow['100']};
  }
`);
const SetupGuideLayout = ({
  children
}) => {
  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsxs(SetupGuideNavLayout, {
    children: [/*#__PURE__*/_jsx(SetupGuideNavContainer, {
      children: /*#__PURE__*/_jsx(SetupGuideNav, {})
    }), children]
  });
};
export default SetupGuideLayout;